import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import Post from './Post';

export default function Feed() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const q = query(collection(db, 'posts'), orderBy('createdDate', 'desc'));
    const unsub = onSnapshot(q, (snapshot) => {
      setPosts(snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })).filter(post => (post.isDraft === undefined || post.isDraft === false) && (post.disabled === undefined || post.disabled === null || post.disabled === false)));
    });
    return () => unsub();
  }, []);

  return (
    <div className="space-y-4">
      {posts.map(post => <Post key={post.id || post.createdDate} post={post} />)}
    </div>
  );
}